import { useContext, useRef, useState } from 'react';
import { AppContext } from '../util/AppContext';
import { getConfigValue } from '../util/getConfigValue';
import { updateFavoriteHcp } from '../API/prescriber';
import { useErrorBoundary } from 'react-error-boundary';
import PropType from 'prop-types';
import Tooltip from './Tooltip';

FavoriteDesignation.propTypes = {
	hcp: PropType.shape({
		id: PropType.string.isRequired,
		favorite: PropType.bool,
	}).isRequired,
	updateCallback: PropType.func,
};

function FavoriteDesignation({ hcp, updateCallback }) {
	const [appState] = useContext(AppContext);
	const { showBoundary } = useErrorBoundary();
	const hcpFavoritesEnabled = getConfigValue(appState.config.HCP?.Favorites?.Enabled, appState)?.Value === 'true';
	const favoriteOnTooltip = getConfigValue(appState.config.HCP?.Favorites?.Tooltip?.On, appState)?.Value || 'Remove from favorites';
	const favoriteOffTooltip = getConfigValue(appState.config.HCP?.Favorites?.Tooltip?.Off, appState)?.Value || 'Add to favorites';
	const tooltipTarget = useRef(null);
	const [showTooltip, setShowTooltip] = useState(false);

	function handleFavoriteClick(hcp) {
		if (updateCallback) {
			updateCallback();
		}
		//if currently favorite, it will remove it, otherwise add it
		updateFavoriteHcp(hcp.id, hcp.favorite || false).catch((error) => {
			showBoundary(error);
		});
	}
	return (
		hcpFavoritesEnabled && (
			<>
				<div
					className='icon-star'
					onClick={() => {
						handleFavoriteClick(hcp);
					}}
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
							handleFavoriteClick(hcp);
						}
					}}
				>
					<span
						className={`fa-${hcp.favorite ? 'solid' : 'light'} fa-star`}
						ref={tooltipTarget}
						onMouseOver={() => setShowTooltip(true)}
						onFocus={() => setShowTooltip(true)}
						onMouseOut={() => setShowTooltip(false)}
						onBlur={() => setShowTooltip(false)}
						role='button'
						tabIndex='0'
					></span>
				</div>
				<Tooltip
					text={hcp.favorite ? favoriteOnTooltip : favoriteOffTooltip}
					placement='top'
					ref={tooltipTarget}
					showTooltip={showTooltip}
					index={hcp.id}
				/>
			</>
		)
	);
}

function updateHcpAppState(hcp, setAppState) {
	setAppState((prevState) => {
		if (!prevState?.prescriber?.id) {
			return prevState;
		}
		return { ...prevState, prescriber: { ...prevState.prescriber, favorite: !hcp.favorite } };
	});
}

export { FavoriteDesignation, updateHcpAppState };
